<div class="contacts">

  <h2>
    Организация
  </h2>
  <span>
    Empresário em Nome Individual | Daria Dombrova | Número fiscal 313 283 834
  </span>
  <h2>Адрес</h2>
  <a href="{{addressLink}}" target="_blank">Rua do Almada 448, 4050-034 Porto </a>
  <h2>Время работы</h2>
  <span>Ежедневно с 10:00 до 19:00</span>
  <h2>Телефон</h2>
  <span>+351 938 135 157 (NOS)</span>
  <h2>email</h2>
  <span>info@varenkabooks.com</span>
  <h2>Dispomos de livro de reclamações</h2>
  <a href="https://www.livroreclamacoes.pt/" target="_blank">Dispomos de livro de reclamações</a>
  <h2>Политика приватности</h2>
  <span>Политика приватности.</span>
  <h2>Возврат товара</h2>
  <div class="delivery-info">
    Вы можете вернуть свою покупку в течение 14 дней с момента получения заказа. К возврату принимаются только те
    товары, которые вы приобрели за полную стоимость.
    Товар, проданный по акции, на распродаже или со скидкой, к возврату не принимается.
    Согласно статье 12 части 6 закона Латвийской Республики «О защите прав потребителей»,
    потребитель в течение срока действия права на возврат несет ответственность за сохранность и качество товара.
    Мы оставляем за собой право отказать покупателю в возврате товара, если товар находился в эксплуатации,
    поврежден, не в полной комплектации, потерял свой первоначальный вид (заметны царапины, мятые углы и подобные
    дефекты),
    при возврате товар не был достаточно герметично упакован (не защищены углы книг, не защищена обложка от царапин и
    изгибов), что привело к порче товара.
    При возврате товара необходимо предъявить оригинал документа, подтверждающий покупку (накладную или чек кассового
    аппарата).
    Возврат товара осуществляется через ваше местное почтовое отделение или международной курьерской службой. При
    возврате товара деньги за
    осуществленную доставку не возвращаются.Пожалуйста, скачайте, распечатайте и заполните форму возврата.
    Упакуйте товар так, чтобы он не деформировался: был в герметичной и твёрдой упаковке, уголки надёжно защищены,
    обложка не подвержена изгибам и царапинам.
    Прикрепите к посылке заполненную форму возврата и отправьте по следующему адресу:<br/>
    <b>Rua 26, 291, Espinho, Portugal, 4500-163</b>
  </div>

</div>
